<template>
  <div class="plan-wrapper">
    <div class="">
      <div
        class="h-ttl"
        v-bind:class="[
          { p1: num % 3 === 0 },
          { p2: num % 3 === 1 },
          { p3: num % 3 === 2 }
        ]"
      ></div>
      <div class="ttl" v-if="planObj.duration_in_days >= 30">
        {{ planObj.duration_in_days / 30 + " Month " + planObj.plan_name }}
      </div>
      <div class="ttl" v-else>
        {{ planObj.duration_in_days + " Days " + planObj.plan_name }}
      </div>
      <div class="price">
        <span style="font-size:1.8rem; color: #6c6c6c; margin-right: 0.5rem"
          >BDT</span
        ><span class="prc-text">{{ planObj.price }}</span>
      </div>
    </div>
    <div class="features">
      <div :key="index" v-for="(feature, index) in featureKeys" class="feature">
        <v-icon class="c-ico">mdi-check</v-icon>
        {{ feature.prefix }} <b>{{ feature.val }}</b> {{ feature.suffix }}
      </div>
      <div class="feature">
        <v-icon class="c-ico">mdi-check</v-icon>
        Plan duration <b>{{ planObj.duration_in_days }}</b> days
      </div>
    </div>
    <div v-if="!hideEdit" class="edit" style="text-align: center;">
      <button
        v-bind:class="[{ btnFade: saved }]"
        @click="editPlan"
        class="button-sign-in"
        style="border-radius: 50rem; width: 100%"
      >
        {{ buttonAction }}
      </button>
      <div v-if="saved" style="margin-top: 1rem">
        <button
          @click="publishPlan"
          class="btn btn-save-new"
          style="border-radius: 50rem; width: 100%"
        >
          Publish
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { IsEmptyObject } from "../../globalFunctions";
import { OPERATOR } from "../../adminConstants";

export default {
  name: "plan-template",
  props: {
    planObj: Object,
    index: Number,
    action: String,
    hideEdit: Boolean,
    saved: Boolean
  },
  data: function() {
    return {
      num: this.index,
      buttonAction: this.action || "Edit",
      featureKeys: []
    };
  },
  methods: {
    editPlan() {
      this.$emit("edit-plan");
    },
    publishPlan() {
      const self = this;
      let plan = {
        plan_name: self.planObj.plan_name,
        duration_in_days: parseInt(self.planObj.duration_in_days),
        price: parseInt(self.planObj.price),
        plan_id: self.planObj.plan_id,
        plan_status: 2
      };
      plan.attributes = {
        conditions: self.planObj.features
      };
      self.$emit("publish-plan", plan);
    }
  },
  mounted() {
    const self = this;
    if (!IsEmptyObject(self.planObj)) {
      let i;
      let length = self.planObj.features.length;
      for (i = 0; i < length; i++) {
        let key = self.planObj.features[i].key;
        let val = self.planObj.features[i].value;
        let pre, mid, suf;
        mid = OPERATOR[self.planObj.features[i].op];
        switch (parseInt(key)) {
          case 306:
            pre = "Post";
            suf = " jobs";
            self.featureKeys.push({
              prefix: pre + " " + mid,
              suffix: suf,
              val: val,
              priority: length
            });
            break;
          case 307:
            pre = "View";
            suf = " CVs";
            self.featureKeys.push({
              prefix: pre + " " + mid,
              suffix: suf,
              val: val,
              priority: length
            });
            break;
        }
      }
    }
  }
};
</script>

<style scoped>
.plan-wrapper {
  position: relative;
  background-color: #ffffff;
  border-radius: 0.8rem;
  box-shadow: 0 0.8rem 1.6rem 0 rgba(0, 0, 0, 0.16);
  max-width: 35rem;
  min-height: 50rem;
}
.h-ttl {
  padding: 1rem 0;
  height: 9.2rem;
}
.p1 {
  background-image: url("../../assets/newDesign/top-maks.png");
}
.p2 {
  background-image: url("../../assets/newDesign/top-maks-2.png");
}
.p3 {
  background-image: url("../../assets/newDesign/top-maks-3.png");
}
.ttl {
  margin-top: 2rem;
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.25;
  text-align: center;
  color: #121212;
}
.price {
  line-height: 1.25;
  margin-top: 1rem;
}
.prc-text {
  color: #34334a;
  font-size: 6.4rem;
  line-height: 1.25;
  letter-spacing: -0.16rem;
  font-weight: bold;
}
.features {
  padding: 2rem;
  text-align: left;
}
.feature {
  margin: 0.8rem 0;
}
.c-ico {
  color: var(--button-color);
  margin-right: 0.5rem;
}
.edit {
  padding: 2rem;
  position: absolute;
  bottom: 0;
  width: 100%;
}
.btnFade {
  background-color: var(--synop-select-color);
  color: #050505;
}
.btnFade:hover {
  color: #ffffff !important;
}
</style>
